<template>
  <footer class="footer footer-app">
    <span>Oxperta Express</span>
    <span>Versión {{ version }}</span>
  </footer>
</template>
<script>
import { appVersion } from "@/globalVars";
export default {
  data() {
    return {
      version: appVersion,
    };
  },
};
</script>
<style scoped>
.footer-app {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  padding: 0 15px;
  font-size: 12px;
  color: #909399;
}
</style>
